const getCurrentCarrier = (state) => state.carrierSection.currentCarrier;
const isLoading = (state) => state.carrierSection.loading;
const getVehicles = (state) =>
  state.carrierSection.currentCarrier ? state.carrierSection.currentCarrier.vehicles : [];
const getDrivers = (state) =>
  state.carrierSection.currentCarrier ? state.carrierSection.currentCarrier.drivers : [];
const getVehicleById = (state, id) =>
  state.carrierSection.currentCarrier && Array.isArray(state.carrierSection.currentCarrier.vehicles)
    ? state.carrierSection.currentCarrier.vehicles.find((vehicle) => vehicle.id === id)
    : {};
const getDriverById = (state, id) =>
  state.carrierSection.currentCarrier && Array.isArray(state.carrierSection.currentCarrier.drivers)
    ? state.carrierSection.currentCarrier.drivers.find((driver) => driver.id === id)
    : {};

export { getCurrentCarrier, isLoading, getVehicles, getDrivers, getVehicleById, getDriverById };
